import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { UnsavedConditionMonitoringForNodeManagerNavigationModal } from "@src/components/organisms/modals/unsaved-condition-monitoring-for-node-manager-navigation-modal/unsaved-condition-monitoring-for-node-manager-navigation-modal";

export const UnsavedConditionMonitoringForNodeManagerNavigation = () => {
  const showUnsavedConditionMonitoringForNodeManagerNavigationModal =
    useSelector(
      (state: RootState) =>
        state.yourSlice.unsavedConditionMonitoringForNodeManagerNavigationModal
          .showUnsavedConditionMonitoringForNodeManagerNavigationModal,
    );

  return (
    <>
      {showUnsavedConditionMonitoringForNodeManagerNavigationModal && (
        <UnsavedConditionMonitoringForNodeManagerNavigationModal />
      )}
    </>
  );
};
